;(function () {
  'use strict'

  angular
    .module('admin.channel_prize_banners.service', [])
    .factory('ChannelPrizeBannersService', ChannelPrizeBannersService)

  /** @ngInject */
  function ChannelPrizeBannersService($http, $q, API) {
    function list(start, limit, sort, title) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL + 'admin/channel_prize_banners',
          // ?start=' +
          // start +
          // '&limit=' +
          // limit +
          // '&sort=' +
          // sort +
          // '&t=' +
          // title,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function get(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/channel_prize_banners/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function create(model) {
      const newModel = { ...model }
      console.log(newModel)
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/channel_prize_banners', newModel)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'admin/channel_prize_banners/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'admin/channel_prize_banners/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list: list,
      get: get,
      create: create,
      update: update,
      remove: remove,
    }
  }
})()
